@if (available) {
  <button
    [matMenuTriggerFor]="mapDataMenu"
    class="export-menu-button"
    data-testid="reports-map-data-menu"
    aria-label="Export map data"
    matTooltip="Export map data"
    type="button">
    @if (exporting) {
      <mat-spinner color="primary" diameter="20" mode="indeterminate" strokeWidth="2" />
    } @else {
      <mat-icon>more_horiz</mat-icon>
    }
  </button>
  <mat-menu #mapDataMenu="matMenu" xPosition="before">
    <div class="report-map-data-menu-heading">Export map data ({{ reportIds.length }} report{{ reportIds.length === 1 ? '' : 's' }})</div>
    @for (option of options; track option.format) {
      <button
        (click)="export(option.format)"
        [attr.data-testid]="'reports-map-data-' + option.format"
        [disabled]="!!exporting || !reportIds.length"
        mat-menu-item>
        <mat-icon>{{ option.icon }}</mat-icon>
        <span>{{ option.label }}</span>
      </button>
    }
  </mat-menu>
}
